import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=16de0de4&scoped=true"
import script from "./ErrorNotification.vue?vue&type=script&lang=js"
export * from "./ErrorNotification.vue?vue&type=script&lang=js"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=16de0de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de0de4",
  null
  
)

export default component.exports